"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../request/models");
var ListDeliverableRequest = /** @class */ (function () {
    function ListDeliverableRequest() {
    }
    return ListDeliverableRequest;
}());
exports.ListDeliverableRequest = ListDeliverableRequest;
var CompleteApprovalPhaseRequest = /** @class */ (function () {
    function CompleteApprovalPhaseRequest() {
    }
    return CompleteApprovalPhaseRequest;
}());
exports.CompleteApprovalPhaseRequest = CompleteApprovalPhaseRequest;
var RejectRevisionRequest = /** @class */ (function () {
    function RejectRevisionRequest() {
    }
    return RejectRevisionRequest;
}());
exports.RejectRevisionRequest = RejectRevisionRequest;
var CompletePhaseRequest = /** @class */ (function () {
    function CompletePhaseRequest() {
    }
    return CompletePhaseRequest;
}());
exports.CompletePhaseRequest = CompletePhaseRequest;
var AssociatedAssetFile = /** @class */ (function () {
    function AssociatedAssetFile() {
    }
    return AssociatedAssetFile;
}());
exports.AssociatedAssetFile = AssociatedAssetFile;
var ListRequest = /** @class */ (function () {
    function ListRequest() {
    }
    return ListRequest;
}());
exports.ListRequest = ListRequest;
var ListPhasesRequest = /** @class */ (function () {
    function ListPhasesRequest() {
    }
    return ListPhasesRequest;
}());
exports.ListPhasesRequest = ListPhasesRequest;
var ListUncreatedRequest = /** @class */ (function () {
    function ListUncreatedRequest() {
    }
    return ListUncreatedRequest;
}());
exports.ListUncreatedRequest = ListUncreatedRequest;
var RoleHintRequestWithType = /** @class */ (function (_super) {
    __extends(RoleHintRequestWithType, _super);
    function RoleHintRequestWithType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RoleHintRequestWithType;
}(models_1.RoleHintRequest));
exports.RoleHintRequestWithType = RoleHintRequestWithType;
var ListProjectsPMRequest = /** @class */ (function () {
    function ListProjectsPMRequest() {
    }
    return ListProjectsPMRequest;
}());
exports.ListProjectsPMRequest = ListProjectsPMRequest;
var ListPhasesPMRequest = /** @class */ (function () {
    function ListPhasesPMRequest(page, pageSize, ownerId, workStatusTypes, currentPhaseWorkTypeId, feedId, fromDate, toDate, productIds, orderByCriteria, hasUnits, justOwner, moduleIds, createdFrom, businessUnits) {
        this.page = page;
        this.pageSize = pageSize;
        this.ownerId = ownerId;
        this.workStatusTypes = workStatusTypes;
        this.currentPhaseWorkTypeId = currentPhaseWorkTypeId;
        this.feedId = feedId;
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.productIds = productIds;
        this.orderByCriteria = orderByCriteria;
        this.hasUnits = hasUnits;
        this.justOwner = justOwner;
        this.moduleIds = moduleIds;
        this.createdFrom = createdFrom;
        this.businessUnits = businessUnits;
    }
    return ListPhasesPMRequest;
}());
exports.ListPhasesPMRequest = ListPhasesPMRequest;
var ListContractsPMRequest = /** @class */ (function () {
    function ListContractsPMRequest(page, pageSize, ownerId, feedId, workStatusTypes, fromDate, toDate) {
        this.page = page;
        this.pageSize = pageSize;
        this.ownerId = ownerId;
        this.feedId = feedId;
        this.workStatusTypes = workStatusTypes;
        this.fromDate = fromDate;
        this.toDate = toDate;
    }
    return ListContractsPMRequest;
}());
exports.ListContractsPMRequest = ListContractsPMRequest;
// start account manager request view model
var ListContractsForCMSRequest = /** @class */ (function () {
    function ListContractsForCMSRequest() {
    }
    return ListContractsForCMSRequest;
}());
exports.ListContractsForCMSRequest = ListContractsForCMSRequest;
;
var ListProjectsForCMSRequest = /** @class */ (function () {
    function ListProjectsForCMSRequest() {
    }
    return ListProjectsForCMSRequest;
}());
exports.ListProjectsForCMSRequest = ListProjectsForCMSRequest;
var ListPendingssForCMSRequest = /** @class */ (function () {
    function ListPendingssForCMSRequest() {
    }
    return ListPendingssForCMSRequest;
}());
exports.ListPendingssForCMSRequest = ListPendingssForCMSRequest;
;
// end account manager request view model
// start accounts request view model
var ListProjectsAccountsRequest = /** @class */ (function () {
    function ListProjectsAccountsRequest() {
    }
    return ListProjectsAccountsRequest;
}());
exports.ListProjectsAccountsRequest = ListProjectsAccountsRequest;
var ListPhasesAccountsRequest = /** @class */ (function () {
    function ListPhasesAccountsRequest() {
    }
    return ListPhasesAccountsRequest;
}());
exports.ListPhasesAccountsRequest = ListPhasesAccountsRequest;
var ListContractsAccountsRequest = /** @class */ (function () {
    function ListContractsAccountsRequest() {
    }
    return ListContractsAccountsRequest;
}());
exports.ListContractsAccountsRequest = ListContractsAccountsRequest;
// end accounts request view model
